import type { ActorView } from "../../queries.ts";
import { formatError } from "../api.ts";
import { authState, signIn } from "../auth.ts";
import { actorState, canModerate, setBlocked, setMuted } from "../filters.ts";
import { menuItem } from "./menu.tsx";
import { confirmDialog } from "./confirm.tsx";

/** Mute/block menu entries for another account, or a re-authorization prompt without the scopes. */
export function moderationItems(actor: ActorView): Element[] {
  const state = authState.get();
  if (state.status !== "authenticated" || state.did === actor.did) return [];
  const viewer = state.did as `did:${string}`;
  const subject = actor.did as `did:${string}`;
  const name = actor.handle ? `@${actor.handle}` : "account";
  if (!canModerate(state)) {
    return [menuItem("Authorize mute and block…", () => void signIn(viewer, location.pathname))];
  }
  const { muted, blocked } = actorState(subject);
  const report = (task: Promise<void>) => task.catch((error) => alert(formatError(error)));
  return [
    menuItem(`${muted ? "Unmute" : "Mute"} ${name}`, () => report(setMuted(subject, !muted))),
    menuItem(`${blocked ? "Unblock" : "Block"} ${name}`, () => {
      if (blocked) {
        void report(setBlocked(viewer, subject, !blocked));
        return;
      }
      void confirmDialog(`Block ${name}? They will no longer see your posts.`, "Block").then(
        (confirmed) => {
          if (confirmed) void report(setBlocked(viewer, subject, !blocked));
        },
      );
    }, "danger-action"),
  ];
}
